(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Testimonial"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  // Swiper initialization
  new Swiper(".review-swiper", {
  slidesPerView: 1,
  spaceBetween: 20,
  loop: true,
  centeredSlides: false,

  navigation: {
    nextEl: ".sliders-button-next",
    prevEl: ".sliders-button-prev",
  },

  pagination: {
    el: ".swiper-paginations",
    clickable: true,
  },

  breakpoints: {

    /* Mobile */
    0: {
      slidesPerView: 1.2,
      centeredSlides: true,
      spaceBetween: 16,
    },

    /* Small tablets */
    640: {
      slidesPerView: 2,
      centeredSlides: false,
    },

    /* Tablets */
    768: {
      slidesPerView: 2.8,
      centeredSlides: true,
    },

    /* Desktop */
    1024: {
      slidesPerView: 4,
      centeredSlides: false,
    },

    /* Large screens */
    1680: {
      slidesPerView: 5,
    }
  },
});

  // Read More / Read Less functionality
  const snippets = document.querySelectorAll(".review-snippet");
  snippets.forEach(function (snippet) {
    const fullText = snippet.textContent.trim();
    const charLimit = 140;

    if (fullText.length > charLimit) {
      const shortText = fullText.slice(0, charLimit) + "...";
      snippet.setAttribute("data-full", fullText);
      snippet.setAttribute("data-short", shortText);
      snippet.textContent = shortText;

      const toggleBtn = document.createElement("a");
      toggleBtn.href = "#";
      toggleBtn.textContent = "Read More";
      toggleBtn.className = "read-more-toggle";
      snippet.parentNode.appendChild(toggleBtn);

      toggleBtn.addEventListener("click", function (e) {
        e.preventDefault();
        const isExpanded = toggleBtn.textContent === "Read Less";
        snippet.textContent = isExpanded
          ? snippet.getAttribute("data-short")
          : snippet.getAttribute("data-full");
        toggleBtn.textContent = isExpanded ? "Read More" : "Read Less";
      });
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["birthstone-edit"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.birthstone-edit').forEach(function (section) {
  var triggers = section.querySelectorAll('[data-birthstone-trigger]');
  var images = section.querySelectorAll('[data-birthstone-image]');
  var labelEl = section.querySelector('[data-birthstone-label]');
  var linkEl = section.querySelector('[data-birthstone-link]');
  var buttonLabelEl = section.querySelector('[data-birthstone-button-label]');

  triggers.forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var index = trigger.getAttribute('data-index');

      triggers.forEach(function (t) {
        var isActive = t === trigger;
        t.classList.toggle('is-active', isActive);
        t.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      images.forEach(function (img) {
        img.classList.toggle('is-active', img.getAttribute('data-index') === index);
      });

      if (labelEl) {
        labelEl.textContent = trigger.getAttribute('data-ring-label') || '';
      }

      if (buttonLabelEl) {
        buttonLabelEl.textContent = trigger.getAttribute('data-button-label') || '';
      }

      if (linkEl) {
        var link = trigger.getAttribute('data-ring-link');
        if (link) {
          linkEl.setAttribute('href', link);
          linkEl.removeAttribute('aria-disabled');
        } else {
          linkEl.setAttribute('href', '#');
        }
      }

      section.setAttribute('data-active-index', index);
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
